<template>

    <v-footer dark flat  dense class="cfbg mt-8">
      <div>
        Research and Development by Alessandro Mantelli (2020-) - Department of Asian and North African Studies - Ca' Foscari University of Venice
      </div>
      <slot></slot>
    </v-footer>
 
</template>
<script>

export default {
}
</script>
